define("checkout/components/containers/load-checkout-data", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/tracking", "ember-concurrency-decorators", "ember-concurrency", "later/utils/object-methods", "shared/utils/constants/ada-campaigns"], function (_exports, _component, _templateFactory, _component2, _object, _service, _utils, _tracking, _emberConcurrencyDecorators, _emberConcurrency, _objectMethods, _adaCampaigns) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _convertPercentOffToAmountOff, _discountApplicableToSelectedPlan;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/tracking",0,"ember-concurrency-decorators",0,"ember-concurrency",0,"later/utils/object-methods",0,"shared/utils/constants/ada-campaigns",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{!-- Usage:
    <Containers::LoadCheckoutData
      @planType={{@planType}}
      @onTransactionComplete={{this.handleTransactionComplete}}
      as |checkout checkoutActions proration|>
    </Containers::LoadCheckoutData>
   --}}
  <Proration
    @subscription={{this.subscription}}
    @initialTeamMemberCount={{this.initialTeamMemberCount}}
    @initialSocialSetCount={{this.initialSocialSetCount}}
    @additionalTeamMemberCount={{this.additionalTeamMemberCount}}
    @additionalSocialSetCount={{this.additionalSocialSetCount}}
    @selectedSubscriptionPlan={{this.selectedSubscriptionPlan}}
    @currentSubscriptionPlan={{this.currentSubscriptionPlan}}
    @totalCost={{this.totalCost}}
    as |proration|
  >
    <div {{did-insert (perform this.loadData)}} >
      {{yield (hash
        additionalTeamMemberCount=this.additionalTeamMemberCount
        additionalSocialSetCount=this.additionalSocialSetCount
        canAddons=this.canAddons
        card=this.card
        coupon=this.coupon
        currentAccount=this.currentAccount
        currentSubscriptionPlan=this.currentSubscriptionPlan
        discount=this.discount
        hasActiveSubscription=this.hasActiveSubscription
        hasActiveTrial=this.hasActiveTrial
        hasCheckoutChanges=this.hasCheckoutChanges
        hasAddonChange=this.hasAddonChange
        hasEmptyCard=this.hasEmptyCard
        isMonthly=this.isMonthly
        isReady=this.isReady
        isEligibleForTrial=this.isEligibleForTrial
        isSameInterval=this.isSameInterval
        isSamePlan=this.isSamePlan
        monthlyPlan=this.monthlyPlan
        plan=this.plan
        planName=this.planName
        selectedSubscriptionPlan=this.selectedSubscriptionPlan
        stripeCard=this.stripeCard
        subscription=this.subscription
        totalSocialSetCost=this.totalSocialSetCost
        totalTeamMemberCost=this.totalTeamMemberCost
        totalCost=this.totalCost
        trialDaysRemaining=this.trialDaysRemaining
        yearlyPlan=this.yearlyPlan
      )
      (hash
        handleInterval=this.handleInterval
        handleStripeCard=this.handleStripeCard
        handleStripeCardChange=this.handleStripeCardChange
        handleCoupon=this.handleCoupon
        handleTeamMemberChange=this.handleTeamMemberChange
        handleSocialSetChange=this.handleSocialSetChange
        updateTeamMemberSelection=this.updateTeamMemberSelection
        updateSocialSetSelection=this.updateSocialSetSelection
        handleChangePlan=this.handleChangePlan
        handleCheckout=this.handleCheckout
      )
      proration
    }}
  
    </div>
  </Proration>
  
  */
  {
    "id": "7GgaXUrP",
    "block": "[[[8,[39,0],null,[[\"@subscription\",\"@initialTeamMemberCount\",\"@initialSocialSetCount\",\"@additionalTeamMemberCount\",\"@additionalSocialSetCount\",\"@selectedSubscriptionPlan\",\"@currentSubscriptionPlan\",\"@totalCost\"],[[30,0,[\"subscription\"]],[30,0,[\"initialTeamMemberCount\"]],[30,0,[\"initialSocialSetCount\"]],[30,0,[\"additionalTeamMemberCount\"]],[30,0,[\"additionalSocialSetCount\"]],[30,0,[\"selectedSubscriptionPlan\"]],[30,0,[\"currentSubscriptionPlan\"]],[30,0,[\"totalCost\"]]]],[[\"default\"],[[[[1,\"\\n  \"],[11,0],[4,[38,1],[[28,[37,2],[[30,0,[\"loadData\"]]],null]],null],[12],[1,\"\\n    \"],[18,2,[[28,[37,4],null,[[\"additionalTeamMemberCount\",\"additionalSocialSetCount\",\"canAddons\",\"card\",\"coupon\",\"currentAccount\",\"currentSubscriptionPlan\",\"discount\",\"hasActiveSubscription\",\"hasActiveTrial\",\"hasCheckoutChanges\",\"hasAddonChange\",\"hasEmptyCard\",\"isMonthly\",\"isReady\",\"isEligibleForTrial\",\"isSameInterval\",\"isSamePlan\",\"monthlyPlan\",\"plan\",\"planName\",\"selectedSubscriptionPlan\",\"stripeCard\",\"subscription\",\"totalSocialSetCost\",\"totalTeamMemberCost\",\"totalCost\",\"trialDaysRemaining\",\"yearlyPlan\"],[[30,0,[\"additionalTeamMemberCount\"]],[30,0,[\"additionalSocialSetCount\"]],[30,0,[\"canAddons\"]],[30,0,[\"card\"]],[30,0,[\"coupon\"]],[30,0,[\"currentAccount\"]],[30,0,[\"currentSubscriptionPlan\"]],[30,0,[\"discount\"]],[30,0,[\"hasActiveSubscription\"]],[30,0,[\"hasActiveTrial\"]],[30,0,[\"hasCheckoutChanges\"]],[30,0,[\"hasAddonChange\"]],[30,0,[\"hasEmptyCard\"]],[30,0,[\"isMonthly\"]],[30,0,[\"isReady\"]],[30,0,[\"isEligibleForTrial\"]],[30,0,[\"isSameInterval\"]],[30,0,[\"isSamePlan\"]],[30,0,[\"monthlyPlan\"]],[30,0,[\"plan\"]],[30,0,[\"planName\"]],[30,0,[\"selectedSubscriptionPlan\"]],[30,0,[\"stripeCard\"]],[30,0,[\"subscription\"]],[30,0,[\"totalSocialSetCost\"]],[30,0,[\"totalTeamMemberCost\"]],[30,0,[\"totalCost\"]],[30,0,[\"trialDaysRemaining\"]],[30,0,[\"yearlyPlan\"]]]]],[28,[37,4],null,[[\"handleInterval\",\"handleStripeCard\",\"handleStripeCardChange\",\"handleCoupon\",\"handleTeamMemberChange\",\"handleSocialSetChange\",\"updateTeamMemberSelection\",\"updateSocialSetSelection\",\"handleChangePlan\",\"handleCheckout\"],[[30,0,[\"handleInterval\"]],[30,0,[\"handleStripeCard\"]],[30,0,[\"handleStripeCardChange\"]],[30,0,[\"handleCoupon\"]],[30,0,[\"handleTeamMemberChange\"]],[30,0,[\"handleSocialSetChange\"]],[30,0,[\"updateTeamMemberSelection\"]],[30,0,[\"updateSocialSetSelection\"]],[30,0,[\"handleChangePlan\"]],[30,0,[\"handleCheckout\"]]]]],[30,1]]],[1,\"\\n\\n  \"],[13],[1,\"\\n\"]],[1]]]]],[1,\"\\n\"]],[\"proration\",\"&default\"],false,[\"proration\",\"did-insert\",\"perform\",\"yield\",\"hash\"]]",
    "moduleName": "checkout/components/containers/load-checkout-data.hbs",
    "isStrictMode": false
  });

  const DEFAULT_DISCOUNT = 0;
  let Checkout = (_class = (_convertPercentOffToAmountOff = /*#__PURE__*/new WeakSet(), _discountApplicableToSelectedPlan = /*#__PURE__*/new WeakSet(), class Checkout extends _component2.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _discountApplicableToSelectedPlan);

      _classPrivateMethodInitSpec(this, _convertPercentOffToAmountOff);

      _initializerDefineProperty(this, "ada", _descriptor, this);

      _initializerDefineProperty(this, "adaCampaigns", _descriptor2, this);

      _initializerDefineProperty(this, "address", _descriptor3, this);

      _initializerDefineProperty(this, "alerts", _descriptor4, this);

      _initializerDefineProperty(this, "auth", _descriptor5, this);

      _initializerDefineProperty(this, "cache", _descriptor6, this);

      _initializerDefineProperty(this, "errors", _descriptor7, this);

      _initializerDefineProperty(this, "intl", _descriptor8, this);

      _initializerDefineProperty(this, "payment", _descriptor9, this);

      _initializerDefineProperty(this, "plans", _descriptor10, this);

      _initializerDefineProperty(this, "router", _descriptor11, this);

      _initializerDefineProperty(this, "segment", _descriptor12, this);

      _initializerDefineProperty(this, "segmentEvents", _descriptor13, this);

      _initializerDefineProperty(this, "session", _descriptor14, this);

      _initializerDefineProperty(this, "store", _descriptor15, this);

      _initializerDefineProperty(this, "stripe", _descriptor16, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor17, this);

      _initializerDefineProperty(this, "additionalSocialSetCount", _descriptor18, this);

      _initializerDefineProperty(this, "additionalTeamMemberCount", _descriptor19, this);

      _initializerDefineProperty(this, "card", _descriptor20, this);

      _initializerDefineProperty(this, "coupon", _descriptor21, this);

      _initializerDefineProperty(this, "hasSocialSetsAddonsChanged", _descriptor22, this);

      _initializerDefineProperty(this, "hasUsersAddOnsChanged", _descriptor23, this);

      _initializerDefineProperty(this, "selectedSubscriptionPlan", _descriptor24, this);

      _initializerDefineProperty(this, "socialProfileType", _descriptor25, this);

      _initializerDefineProperty(this, "stripeCard", _descriptor26, this);
    }

    get canSelectMonthlyInterval() {
      return this.plans.canSelectMonthlyInterval;
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get hasActiveTrial() {
      return this.subscriptions.hasActiveTrial;
    }

    get hasActiveCancelledSubscription() {
      return this.currentAccount.hasActiveCancelledSubscription;
    }

    get hasActiveSubscription() {
      var _this$handleCheckout$;

      return this.currentAccount.hasActiveSubscription && !this.handleCheckout.isRunning && !((_this$handleCheckout$ = this.handleCheckout.last) !== null && _this$handleCheckout$ !== void 0 && _this$handleCheckout$.isSuccessful);
    }

    get hasAddonChange() {
      return this.additionalSocialSetCount > 0 || this.additionalTeamMemberCount > 0;
    } // Note: used to determine if an alert should appear to the user when leaving checkout


    get hasCheckoutChanges() {
      var _this$card, _this$card$state;

      return this.hasAddonChange || this.card && !((_this$card = this.card) !== null && _this$card !== void 0 && (_this$card$state = _this$card.state) !== null && _this$card$state !== void 0 && _this$card$state.empty) || this.coupon;
    }

    get hasEmptyCard() {
      var _this$card2, _this$card2$state;

      return !this.card || ((_this$card2 = this.card) === null || _this$card2 === void 0 ? void 0 : (_this$card2$state = _this$card2.state) === null || _this$card2$state === void 0 ? void 0 : _this$card2$state.empty);
    }

    get includedSocialSetCount() {
      var _this$selectedSubscri;

      return (_this$selectedSubscri = this.selectedSubscriptionPlan) === null || _this$selectedSubscri === void 0 ? void 0 : _this$selectedSubscri.numberOfSocialSets;
    }

    get includedTeamMemberCount() {
      var _this$selectedSubscri2;

      return (_this$selectedSubscri2 = this.selectedSubscriptionPlan) === null || _this$selectedSubscri2 === void 0 ? void 0 : _this$selectedSubscri2.numberOfUsers;
    }

    get industry() {
      return this.currentAccount.mainProfile.industry;
    }

    get initialSocialSetCount() {
      var _this$subscription$ad, _this$subscription;

      return (_this$subscription$ad = (_this$subscription = this.subscription) === null || _this$subscription === void 0 ? void 0 : _this$subscription.additionalSocialSets) !== null && _this$subscription$ad !== void 0 ? _this$subscription$ad : 0;
    }

    get initialTeamMemberCount() {
      var _this$subscription$ad2, _this$subscription2;

      return (_this$subscription$ad2 = (_this$subscription2 = this.subscription) === null || _this$subscription2 === void 0 ? void 0 : _this$subscription2.additionalUsers) !== null && _this$subscription$ad2 !== void 0 ? _this$subscription$ad2 : 0;
    }

    get isMonthly() {
      var _this$selectedSubscri3;

      return (_this$selectedSubscri3 = this.selectedSubscriptionPlan) === null || _this$selectedSubscri3 === void 0 ? void 0 : _this$selectedSubscri3.isMonthly;
    }

    get isSameInterval() {
      if (this.subscription.hasUpcomingPlanChanges) {
        return this.selectedSubscriptionPlan.interval === this.upcomingSubscriptionPlan.interval;
      }

      return this.selectedSubscriptionPlan.interval === this.currentSubscriptionPlan.interval;
    }

    get isSamePlan() {
      if (this.subscription.hasUpcomingPlanChanges) {
        return this.selectedSubscriptionPlan.planType === this.upcomingSubscriptionPlan.planType;
      }

      return this.selectedSubscriptionPlan.planType === this.currentSubscriptionPlan.planType;
    }

    get isEligibleForTrial() {
      // NOTE: for seamless checkout v1 we are only supporting trial starts.
      return true;
    }

    get minimumSocialSetCount() {
      var _this$selectedSubscri4;

      return (_this$selectedSubscri4 = this.selectedSubscriptionPlan) === null || _this$selectedSubscri4 === void 0 ? void 0 : _this$selectedSubscri4.numberOfInstagramProfiles;
    }

    get minimumTeamMemberCount() {
      var _this$selectedSubscri5;

      return (_this$selectedSubscri5 = this.selectedSubscriptionPlan) === null || _this$selectedSubscri5 === void 0 ? void 0 : _this$selectedSubscri5.numberOfUsers;
    }

    get monthlyPlan() {
      var _this$subscriptionPla, _this$subscriptionPla2;

      return (_this$subscriptionPla = this.subscriptionPlans) === null || _this$subscriptionPla === void 0 ? void 0 : (_this$subscriptionPla2 = _this$subscriptionPla.filter(p => p.isMonthly)) === null || _this$subscriptionPla2 === void 0 ? void 0 : _this$subscriptionPla2.firstObject;
    }

    get yearlyPlan() {
      var _this$subscriptionPla3, _this$subscriptionPla4;

      return (_this$subscriptionPla3 = this.subscriptionPlans) === null || _this$subscriptionPla3 === void 0 ? void 0 : (_this$subscriptionPla4 = _this$subscriptionPla3.filter(p => !p.isMonthly)) === null || _this$subscriptionPla4 === void 0 ? void 0 : _this$subscriptionPla4.firstObject;
    }

    get plan() {
      const subscriptionPlan = this.subscriptionPlans.firstObject;
      return subscriptionPlan ? this.plans.plans.find(plan => plan.planType === subscriptionPlan.planType) : null;
    }

    get planName() {
      return this.plan.name;
    }

    get planType() {
      return this.plan.planType;
    }

    get trialDaysRemaining() {
      const trialLength = 14;
      return this.currentAccount.trialDaysRemaining || trialLength;
    }

    get canAddons() {
      var _this$selectedSubscri6;

      return (_this$selectedSubscri6 = this.selectedSubscriptionPlan) === null || _this$selectedSubscri6 === void 0 ? void 0 : _this$selectedSubscri6.canAddons;
    }

    get currentSubscriptionPlan() {
      return this.subscriptions.subscriptionPlan;
    }

    get subscription() {
      return this.subscriptions.subscription;
    }

    get totalSocialSetCost() {
      var _this$selectedSubscri7;

      return this.additionalSocialSetCount * ((_this$selectedSubscri7 = this.selectedSubscriptionPlan) === null || _this$selectedSubscri7 === void 0 ? void 0 : _this$selectedSubscri7.additionalSocialSetCost) || 0;
    }

    get totalTeamMemberCost() {
      var _this$selectedSubscri8;

      return this.additionalTeamMemberCount * ((_this$selectedSubscri8 = this.selectedSubscriptionPlan) === null || _this$selectedSubscri8 === void 0 ? void 0 : _this$selectedSubscri8.additionalUserCost) || 0;
    }

    get totalCostBeforeDiscount() {
      var _this$selectedSubscri9;

      const planAmount = ((_this$selectedSubscri9 = this.selectedSubscriptionPlan) === null || _this$selectedSubscri9 === void 0 ? void 0 : _this$selectedSubscri9.amount) || 0;
      return planAmount + this.totalSocialSetCost + this.totalTeamMemberCost;
    }

    get discount() {
      if (!this.coupon || !_classPrivateMethodGet(this, _discountApplicableToSelectedPlan, _discountApplicableToSelectedPlan2).call(this)) {
        return DEFAULT_DISCOUNT;
      }

      if (this.coupon.amountOff) {
        return Math.min(this.coupon.amountOff, this.totalCostBeforeDiscount);
      }

      if (this.coupon.percentOff) {
        return _classPrivateMethodGet(this, _convertPercentOffToAmountOff, _convertPercentOffToAmountOff2).call(this, this.coupon.percentOff, this.totalCostBeforeDiscount);
      }

      return DEFAULT_DISCOUNT;
    }

    get totalCost() {
      const totalWithDiscount = this.totalCostBeforeDiscount - this.discount;
      return Math.max(totalWithDiscount, 0);
    }
    /**
     * Returns the monthly and yearly plans of the provided planType.
     */


    get subscriptionPlans() {
      return this.subscriptions.subscriptionPlans.filter(plan => plan.planType === this.args.planType);
    }

    handleInterval(subscriptionPlan) {
      this.selectedSubscriptionPlan = subscriptionPlan;
    }

    handleCoupon(coupon) {
      this.coupon = (0, _objectMethods.objectSnakeToCamel)(coupon);
    }

    handleTeamMemberChange(num) {
      const requestedTeamMemberCount = this.additionalTeamMemberCount + num; //this.segmentEvents.trackWithGAIntegration('clicked-add-user');

      this.updateTeamMemberSelection(requestedTeamMemberCount);
    }

    handleSocialSetChange(num) {
      const requestedSocialSetCount = this.additionalSocialSetCount + num; //this.segmentEvents.trackWithGAIntegration('clicked-add-social-set');

      this.updateSocialSetSelection(requestedSocialSetCount);
    }

    updateTeamMemberSelection(requestedTeamMemberCount) {
      const updatedTeamMemberCount = Math.max(requestedTeamMemberCount, 0);
      this.additionalTeamMemberCount = updatedTeamMemberCount;
      this.hasUsersAddOnsChanged = true;
    }

    updateSocialSetSelection(requestedSocialSetCount) {
      const updatedSocialSetCount = Math.max(requestedSocialSetCount, 0);
      this.additionalSocialSetCount = updatedSocialSetCount;
      this.hasSocialSetsAddonsChanged = true;
    }

    *handleCheckout() {
      const isTrialCheckout = true;
      const coupon = this.coupon || {};

      try {
        var _this$args$onTransact, _this$args;

        const {
          payment: response
        } = yield this.payment.processSubscription(this.card.card, this.selectedSubscriptionPlan.stripePlanId, this.additionalTeamMemberCount, this.additionalSocialSetCount, this.totalCost, coupon === null || coupon === void 0 ? void 0 : coupon.id);

        this._trackTransactionComplete(response, isTrialCheckout);

        this.store.unloadAll('subscription');
        yield this.subscriptions.waitForAccountUpdate(1); // Add delay to allow Backend to update models. This should be more robust in a future improvement

        yield (0, _emberConcurrency.timeout)(1000);
        (_this$args$onTransact = (_this$args = this.args).onTransactionComplete) === null || _this$args$onTransact === void 0 ? void 0 : _this$args$onTransact.call(_this$args);
      } catch (error) {
        this.errors.handleAjax(error);
        throw error;
      }
    }

    _trackTransactionComplete(payment, isTrialCheckout) {
      const payload = {
        transaction_id: payment.stripe_subscription_id,
        total: payment.ltv_or_amount,
        value: payment.ltv_or_amount,
        is_trial_checkout: isTrialCheckout,
        authentication_during_checkout: this.isNewAccountFromCheckout || this.isLoginFromCheckout,
        content_name: payment.name,
        content_type: 'product',
        currency: 'USD',
        products: [{
          id: payment.stripe_plan_id,
          sku: payment.stripe_plan_id,
          name: payment.name,
          category: payment.frequency,
          price: payment.ltv_or_amount,
          quantity: 1
        }]
      };
      this.segmentEvents.trackWithGAIntegration('transactionComplete', payload);
      this.adaCampaigns.cacheAbandonedCartEvent(_adaCampaigns.CacheEventName.PurchasedPlan);
      this.ada.trackEvent(_adaCampaigns.TrackEventName.TransactionCompleted);
    }

    *loadData() {
      yield this.address.setup.perform();
      yield this.subscriptions.getAllSubscriptionPlans();
      this.stripeCard = this.payment.retrieveCard.perform();

      if (this.subscriptionPlans) {
        this.selectedSubscriptionPlan = this.monthlyPlan;
      }
    }

    get isReady() {
      var _this$loadData$last;

      return (_this$loadData$last = this.loadData.last) === null || _this$loadData$last === void 0 ? void 0 : _this$loadData$last.isSuccessful;
    }

    handleStripeCard(card) {
      this.card = card;
    } // Note: not used for seamless checkout yet.


    *handleStripeCardChange(token) {
      yield this.stripe.updateCard(token);
      this.cache.remove('card');
      this.creditCard = yield this.payment.retrieveCard.perform();
    } // Note: not used for seamless checkout yet.


    *handleChangePlan() {}

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "ada", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "adaCampaigns", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "segmentEvents", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "session", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "stripe", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "additionalSocialSetCount", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "additionalTeamMemberCount", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "card", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "coupon", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "hasSocialSetsAddonsChanged", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "hasUsersAddOnsChanged", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "selectedSubscriptionPlan", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "socialProfileType", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "stripeCard", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "handleInterval", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInterval"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleCoupon", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleCoupon"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleTeamMemberChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleTeamMemberChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSocialSetChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSocialSetChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateTeamMemberSelection", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateTeamMemberSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSocialSetSelection", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSocialSetSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleCheckout", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "handleCheckout"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadData", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "loadData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleStripeCard", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleStripeCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleStripeCardChange", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "handleStripeCardChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleChangePlan", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "handleChangePlan"), _class.prototype)), _class);
  _exports.default = Checkout;

  function _convertPercentOffToAmountOff2(percentOff, totalApplicableCost) {
    return percentOff / 100 * totalApplicableCost;
  }

  function _discountApplicableToSelectedPlan2() {
    var _this$coupon, _this$coupon$appliesT;

    const hasInvalidCoupon = (0, _utils.isPresent)((_this$coupon = this.coupon) === null || _this$coupon === void 0 ? void 0 : (_this$coupon$appliesT = _this$coupon.appliesTo) === null || _this$coupon$appliesT === void 0 ? void 0 : _this$coupon$appliesT.products) && !this.coupon.appliesTo.products.includes(this.selectedSubscriptionPlan.stripeProductId);
    return !hasInvalidCoupon;
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, Checkout);
});